import React, { useState, useEffect, useCallback } from 'react'
import { Hero } from "shared/components/bulma/hero";
import { sortArrayPipe } from "shared/pipes";
import { v4 as uuidv4 } from 'uuid';
import TableComponent from 'components/table/Table';
import AddComponent from 'components/table/AddComponent';
import { deleteWashWithById, getDetergents, create } from 'controllers/Washwith';



function WashWith() {
  const [inputText, setInputText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [data, setData] = useState([]);

  const handleChange = (event) => {
    setInputText(event.target.value);
  };

  const handleClick = () => {
    const id = uuidv4()
    if (inputText) {
      create({ id: id, value: inputText, label: inputText }, setData, inputText, setInputText, id, setIsLoading, isLoading)
    }

  };

  async function dataStream(callback) {

    const washwith = await getDetergents();
    callback(sortArrayPipe.transform(washwith, 'value'));
  }
  const cachedFn = useCallback(async () => {
    await dataStream((values) => {
      setData(values)
    });
  }, [])

  useEffect(() => {
    cachedFn()
  }, [cachedFn])
  const HandleDelete = (id) => {
    deleteWashWithById(id, setData, isDeleting, setIsDeleting)
  };
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
        <AddComponent
          label="Add Washing"
          buttonlabel="Add Product"
          inputText={inputText}
          handleClick={handleClick}
          handleChange={handleChange}
          placeholder="New Product" />
      </div>
      <Hero>
        <TableComponent
          data={data}
          HandleDelete={HandleDelete}
          updateUrl="update-washwith"

        />
      </Hero>
    </>
  )
}

export default WashWith;